import { FocusNode } from '@please/lrud'
import styled, { css } from 'styled-components'

import { ImageBox } from '@/containers/EventDetailPage/styles'

export const PpvPopup = styled(FocusNode)`
  position: fixed;
  background: ${(props) => props.theme.colors.dialogPopup.overlay};
  height: 1080px;
  width: 1920px;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 13;
`

export const PpvContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 1070px;
  height: 920px;
  background: linear-gradient(
    108deg,
    ${(props) => props.theme.colors.dialogPopup.background.start} 0%,
    ${(props) => props.theme.colors.dialogPopup.background.end} 100%
  );
  padding: 56px 24px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 24px;
  overflow: hidden;
`

export const StatusBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  justify-content: center;
  align-items: center;
`
export const StatusIcon = styled.div`
  height: 100px;
  width: 100px;
  margin-bottom: 24px;
  & img {
    height: 100px;
    width: 100px;
    object-fit: contain;
  }
`
export const StatusLabel = styled.div`
  width: 100%;
  font-size: 32px;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.text};
  font-weight: 400;
  text-transform: uppercase;
  text-align: center;
  padding-bottom: 20px;
`
export const Note = styled.div`
  width: 100%;
  font-size: 20px;
  line-height: 1.6;
  color: ${(props) => props.theme.colors.text};
  font-weight: 500;
  text-align: center;
`
export const Title = styled.h2`
  width: 100%;
  font-size: 32px;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.text};
  font-weight: 700;
  text-transform: uppercase;
  padding-bottom: 56px;
  text-align: center;
`
export const ContentContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 290px;
  margin-bottom: 24px;
`
export const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 500px;
  background: ${(props) => props.theme.colors.eventDetail.background};
  padding: 28px 24px;
  border-radius: 12px;
  h1 {
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 16px;
  }
`
export const BodyTextWrapper = styled.div`
  margin: 16px 0;
  width: 100%;
`
export const BodyText = styled.div`
  width: 100%;
  font-size: 16px;
  color: ${(props) => props.theme.colors.text};
  opacity: 0.9;
  line-height: 24px;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
`
export const ImageBoxWrapper = styled.div`
  position: relative;
  width: 500px;
  height: 290px;
  ${ImageBox} img {
    border-radius: 12px;
  }
`
export const ChannelLogo = styled.div`
  position: absolute;
  top: 20px;
  right: 26px;
  & div {
    justify-content: flex-end;
  }
`

export const PurchaseInfo = styled.div`
  position: relative;
  margin: 0 0 16px;
  width: 100%;
  padding: 20px 24px;
  background: ${(props) => props.theme.colors.eventDetail.background};
  border-radius: 12px;
`
export const PurchaseInfoBlock = styled.div<{
  $accent?: boolean
}>`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 12px 0;
  width: 100%;
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.2em;
  & span {
    font-weight: 400;
    color: ${({ $accent, theme }) =>
      $accent ? theme.colors.accent : theme.colors.text};
  }
`
export const SelectCreditsWrapper = styled.div`
  position: relative;
  width: 100%;
`
export const SelectTitle = styled.div`
  width: 100%;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.text};
  font-weight: 500;
  padding: 0 0 8px 8px;
`
export const SelectCredits = styled(FocusNode)`
  display: flex;
  position: relative;
  width: 100%;
  height: 76px;
`

export const SelectOption = styled(FocusNode)<{
  $isActive: boolean
  $disabled: boolean
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 2%;
  width: 32%;
  padding: 0px 24px;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 600;
  border-radius: 12px;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  &:last-child {
    margin-right: 0;
  }
  & span {
    font-weight: 400;
  }
  background-color: ${({ theme }) => theme.colors.eventDetail.background};
  color: ${({ theme }) => theme.colors.text};
  text-transform: capitalize;
  box-shadow: inset 0 0 0 2px
    ${({ $isActive, theme }) =>
      $isActive ? theme.colors.accent : 'transparent'};
  &.isFocusedLeaf {
    box-shadow: inset 0 0 0 2px
      ${({ theme }) => theme.colors.button.focusedElem.border};
    background-color: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.primary};
  }
`
export const PurchaseText = styled.div`
  margin: 12px 0;
  font-size: 16px;
  color: ${(props) => props.theme.colors.text};
  opacity: 0.9;
  line-height: 24px;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`
export const PurchaseTextWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${PurchaseText} {
    font-size: 20px;
    line-height: 32px;
    font-weight: 400;
  }
`
export const QrCode = styled.img`
  width: 85px;
  height: 85px;
  margin: 0 24px 0 120px;
`
export const Actions = styled(FocusNode)<{ $disabled: boolean }>`
  position: relative;
  display: flex;
  min-height: 80px;
  flex: 1 1;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  ${({ $disabled }) =>
    $disabled &&
    css`
      & button {
        opacity: 0.5;
      }
    `}
`

export const LoaderWrapper = styled.div`
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`

export const WarningText = styled.div`
  font-size: 20px;
  color: ${(props) => props.theme.colors.text};
  line-height: 24px;
  font-weight: 500;
  padding: 0 80px 40px;
  text-align: center;
  & span {
    color: ${({ theme }) => theme.colors.accent};
  }
`
